import React from 'react'
import { Box, CopyButton } from '@node-space/ui-components'

interface CopyTextWrapperProps {
  textToCopy: string
  textContainer?: React.ReactNode
}

export default function CopyTextWrapper({ textToCopy, textContainer }: CopyTextWrapperProps) {
  return (
    <Box flex>
      {textContainer ?? <p className="text-body-regular text-foreground-prominent">{textToCopy}</p>}
      <CopyButton copyText={String(textToCopy)} />
    </Box>
  )
}
